<template>
    <div class="payment-page">
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>
        
        <div v-else class="payment-section">
            <div class="modal-content portal_student">
                <div class="info-payment">
                    <div class="user-info">
                            <h2 class="payment-label">{{ purchase ? 'Dados da compra' : 'Informações do Assinante' }}</h2>
                        <div class="user-details">
                            <div class="detail-item">
                                <span class="label payment-label">Nome:</span>
                                <span class="value">{{nome}}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label payment-label">Email:</span>
                                <span class="value">{{email}}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label payment-label">CPF:</span>
                                <span class="value">{{formatCPF(cpf)}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="modal-body double">
                        <div class="form-group subscription-info">
                            <div class="form-label">
                                <label class="payment-label">{{ purchase ? 'Vencimento do acesso' : 'Próxima Renovação' }}</label>
                            </div>
                            <div class="form-input">
                                <input type="text" class="form-control" disabled :value="nextPayment ? formatDate(nextPayment) : ''">
                                <small class="info-text">{{ purchase ? 'O acesso fica disponível até esta data.' : 'Sua assinatura será renovada automaticamente nesta data' }}</small>
                            </div>
                        </div>

                        <div class="form-group subscription-info">
                            <div class="form-label">
                                <label class="payment-label">{{ purchase ? 'Valor da compra' : 'Valor Mensal' }}</label>
                            </div>
                            <div class="form-input">
                                <input type="text" class="form-control" disabled :value="total ? formatCurrency(total) : ''">
                                <small class="info-text">{{ purchase ? 'Valor pago nesta compra.' : 'Valor cobrado mensalmente no seu cartão' }}</small>
                            </div>
                        </div>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <div class="form-label">
                                <label class="payment-label">Cartão Atual</label>
                            </div>
                            <div class="card-info" v-if="card">
                                <div class="card-details">
                                    <div class="card-icon">
                                        <i class="fas fa-credit-card"></i>
                                    </div>
                                    <div class="card-text">
                                        <div class="card-number">{{card}}</div>
                                        <div class="card-expiry">Validade: {{cardValidity}}</div>
                                    </div>
                                </div>
                                <div class="button-group">
                                    <button @click="showChangeCardModal = true" class="btn-change-card">
                                        <i class="fas fa-sync-alt"></i> Trocar Cartão
                                    </button>
                                    <button @click="showCancelModal = true" class="btn-cancel-subscription">
                                        <i class="fas fa-times"></i> Cancelar Assinatura
                                    </button>
                                </div>
                            </div>
                            <div class="card-info no-card" v-else-if="purchase">
                                <div class="card-warning">
                                    <i class="fas fa-receipt"></i>
                                    <div class="card-number">Pagamento único. O histórico abaixo lista esta compra.</div>
                                </div>
                            </div>
                            <div class="card-info no-card" v-else>
                                <div class="card-warning">
                                    <i class="fas fa-exclamation-triangle"></i>
                                    <div class="card-number">Nenhum cartão cadastrado</div>
                                </div>
                                <div class="button-group">
                                    <button @click="showChangeCardModal = true" class="btn-add-card">
                                        <i class="fas fa-plus"></i> Cadastrar Cartão
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-body payment-history">
                        <div class="form-group">
                            <div class="form-label">
                                <label class="payment-label">Histórico de Pagamentos</label>
                            </div>
                            <div class="payment-history">
                                <div class="history-header">
                                    <span>Data</span>
                                    <span>Valor</span>
                                    <span>Status</span>
                                </div>
                                <div class="history-item" v-for="order in orders" :key="order.id">
                                    <div class="payment-date">
                                        <i class="far fa-calendar-alt"></i>
                                        {{order.charges.paid_at ? formatDate(order.charges.paid_at) : ''}}
                                    </div>
                                    <div class="payment-value">
                                        <i class="fas fa-dollar-sign"></i>
                                        {{order.amount ? formatCurrency(order.amount/100) : ''}}
                                    </div>
                                    <div class="payment-status" :class="{
                                        'status-paid': order.charges.status === 'paid',
                                        'status-pending': order.charges.status === 'pending',
                                        'status-failed': order.charges.status === 'failed'
                                    }">
                                        <svg v-if="order.charges.status === 'paid'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
                                        </svg>
                                        <svg v-if="order.charges.status === 'pending'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/>
                                        </svg>
                                        <svg v-if="order.charges.status === 'failed'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
                                        </svg>
                                        {{order.charges.status === 'paid' ? 'Pago' : 
                                          order.charges.status === 'pending' ? 'Pendente' : 
                                          order.charges.status === 'failed' ? 'Falhou' : ''}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Confirmação -->
        <div class="modal-overlay" v-if="showCancelModal">
            <div class="modal-confirm">
                <i class="fas fa-exclamation-circle warning-icon"></i>
                <h3>Deseja cancelar sua assinatura?</h3>
                <p>Esta ação não poderá ser desfeita e você perderá acesso ao conteúdo premium.</p>
                <div class="modal-buttons">
                    <button @click="confirmCancel" class="btn-confirm">
                        <i class="fas fa-check"></i> Sim, cancelar
                    </button>
                    <button @click="showCancelModal = false" class="btn-cancel">
                        <i class="fas fa-times"></i> Não, manter
                    </button>
                </div>
            </div>
        </div>

        <!-- Modal Trocar Cartão -->
        <div class="modal-overlay" v-if="showChangeCardModal">
            <div class="modal-card">
                <h3><i class="fas fa-credit-card"></i> Alterar Cartão de Crédito</h3>
                <div class="card-form">
                    <div class="form-group">
                        <label class="payment-label">Nome no Cartão</label>
                        <input type="text" v-model="cardForm.name" class="form-control white-input" placeholder="Nome como está no cartão">
                    </div>
                    <div class="form-group">
                        <label class="payment-label">Número do Cartão</label>
                        <input type="text" v-model="cardForm.number" class="form-control white-input" placeholder="0000 0000 0000 0000">
                    </div>
                    <div class="form-row">
                        <div class="form-group half">
                            <label class="payment-label">Data de Validade</label>
                            <input type="text" v-model="cardForm.expiry" class="form-control white-input" placeholder="MM/AA">
                        </div>
                        <div class="form-group half">
                            <label class="payment-label">CVV</label>
                            <input type="text" v-model="cardForm.cvv" class="form-control white-input" placeholder="123">
                        </div>
                    </div>
                </div>
                <div class="modal-buttons">
                    <button @click="saveNewCard" class="btn-confirm">
                        <i class="fas fa-save"></i> Salvar
                    </button>
                    <button @click="showChangeCardModal = false" class="btn-cancel">
                        <i class="fas fa-times"></i> Cancelar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Subscriptions from '../../../utils/Weflix/subscriptions';
import { mapState } from 'vuex';

export default {
    data() {
        return {
            loading: true,
            showCancelModal: false,
            showChangeCardModal: false,
            cardForm: {
                name: '',
                number: '',
                expiry: '',
                cvv: ''
            },
            orders: [],
            card: '',
            cardValidity: '',
            total: 0,
            nextPayment: '',
            nome: '',
            email: '',
            cpf: '',
            purchase: false
        }
    },
    computed: {
        ...mapState(['userPortalWeflix','token'])
    },
    methods: {
        formatDate(date) {
            return new Date(date).toLocaleDateString('pt-BR')
        },
        formatCurrency(value) {
            return value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        formatCPF(cpf) {
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
        },
        getStatusClass(status) {
            return {
                'status-paid': status === 'paid',
                'status-pending': status === 'pending',
                'status-failed': status === 'failed'
            }
        },
        getStatusIcon(status) {
            return {
                'paid': 'fas fa-check-circle',
                'pending': 'fas fa-clock',
                'failed': 'fas fa-times-circle'
            }[status] || 'fas fa-question-circle'
        },
        getStatusText(status) {
            return {
                'paid': 'Pago',
                'pending': 'Pendente',
                'failed': 'Falhou'
            }[status] || 'Desconhecido'
        },
        async getSubscription() {
            try {
                const response = await Subscriptions.getSubscription(this.userPortalWeflix.acessToken ? this.userPortalWeflix.acessToken : this.token);
                this.orders = response.orders?.data || [];
                this.card = response.card || '';
                this.cardValidity = response.cardValidity || '';
                this.total = response.totalpayed || 0;
                this.nextPayment = response.nextPayment || '';
                this.nome = response.nome || '';
                this.email = response.email || '';
                this.cpf = response.cpf || '';
                this.purchase = Boolean(response.purchase);
            } catch (error) {
                console.error('Erro ao obter dados da assinatura:', error);
            } finally {
                this.loading = false;
            }
        },
        async confirmCancel() {
            try {
                await Subscriptions.cancelSubscription(this.userPortalWeflix.acessToken ? this.userPortalWeflix.acessToken : this.token, this.orders[0].subscription.id);
                this.showCancelModal = false;
                await this.getSubscription();
            } catch (error) {
                console.error('Erro ao cancelar assinatura:', error);
            }
        },
        async saveNewCard() {
            const payload = {
                cardNumber: this.cardForm.number,
                cardName: this.cardForm.name,
                cardExpiry: this.cardForm.expiry,
                cardCvv: this.cardForm.cvv
            }
            try {
                const response = await Subscriptions.changeCard(this.userPortalWeflix.acessToken ? this.userPortalWeflix.acessToken : this.token, payload);
                this.showChangeCardModal = false;
                await this.getSubscription();
            } catch (error) {
                console.error('Erro ao alterar cartão:', error);
            }
        }
    },
    created() {
        this.getSubscription();
    }
}
</script>

<style scoped>
.form-control::placeholder {
    color: white;
    opacity: 1;
}

.payment-page {
    width: 100%;
    color: #ffffff;
    background-color: #141414;
    padding: 20px;
}

.user-info {
    background: #1f1f1f;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #333;
}

.user-info h2 {
    color: #fff;
    margin-bottom: 15px;
    font-size: 1.5rem;
}

.user-details {
    display: grid;
    gap: 15px;
}

.detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.detail-item .label {
    color: #888;
    min-width: 80px;
}

.detail-item .value {
    color: #fff;
    font-weight: 500;
}

.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}

.loader {
    border: 4px solid #333;
    border-top: 4px solid #6C5CE7;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

.card-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    background: #1f1f1f;
    border-radius: 12px;
    color: #ffffff;
    border: 1px solid #333;
    margin-top: 1rem;
}

.card-details {
    display: flex;
    align-items: center;
    gap: 15px;
}

.card-icon {
    font-size: 24px;
    color: #6C5CE7;
}

.card-text {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.card-number {
    font-size: 1.1rem;
    font-weight: 500;
}

.card-expiry {
    font-size: 0.9rem;
    color: #888;
}

.button-group {
    display: flex;
    gap: 1rem;
}

.btn-change-card, .btn-add-card {
    background: #404040;
    color: white;
    border: none;
    padding: 0.8rem 1.5rem;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-change-card:hover, .btn-add-card:hover {
    background: #5849c4;
    transform: translateY(-2px);
}

.btn-cancel-subscription {
    background: #000000;
    color: white;
    border: none;
    padding: 0.8rem 1.5rem;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-cancel-subscription:hover {
    background: #ff5252;
    transform: translateY(-2px);
}

.history-header {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 1rem 1.5rem;
    background: #2a2a2a;
    font-weight: 500;
    border-bottom: 1px solid #333;
}

.history-item {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 1.5rem;
    border-bottom: 1px solid #333;
    align-items: center;
}

.payment-status {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    border-radius: 20px;
    font-weight: 500;
    width: fit-content;
}

.status-paid {
    color: #2ed573;
}

.status-pending {
    color: #ffab00;
}

.status-failed {
    color: #ff6b6b;
}

.warning-icon {
    font-size: 48px;
    color: #ffab00;
    margin-bottom: 20px;
}

.info-text {
    display: block;
    color: #888;
    margin-top: 5px;
    font-size: 0.9rem;
}

.payment-label {
    color: #ffffff !important;
}

/* MOBILE IMPROVEMENTS */
@media (max-width: 768px) {
    .payment-page {
        padding: 8px;
    }

    .modal-content.portal_student {
        padding: 0 !important;
        box-shadow: none !important;
    }

    .info-payment {
        padding: 0 !important;
    }

    .user-info {
        padding: 12px;
        margin-bottom: 12px;
        border-radius: 8px;
    }

    .user-info h2 {
        font-size: 1.1rem;
        margin-bottom: 10px;
    }

    .user-details {
        gap: 8px;
    }

    .detail-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
        font-size: 0.98rem;
    }

    .detail-item .label {
        min-width: unset;
        font-size: 0.95rem;
    }

    .detail-item .value {
        font-size: 1rem;
    }

    .modal-body {
        padding: 10px 0 !important;
    }

    .modal-body.double {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 0 !important;
    }

    .form-group.subscription-info {
        margin-bottom: 8px;
    }

    .form-label label {
        font-size: 1rem;
    }

    .form-input input.form-control {
        font-size: 1rem;
        padding: 8px 10px;
    }

    .info-text {
        font-size: 0.85rem;
        margin-top: 2px;
    }

    .card-info {
        flex-direction: column;
        gap: 12px;
        text-align: left;
        padding: 12px;
        border-radius: 8px;
        margin-top: 10px;
    }

    .card-details {
        flex-direction: row;
        align-items: center;
        gap: 10px;
        text-align: left;
    }

    .card-icon {
        font-size: 20px;
    }

    .card-text {
        gap: 2px;
    }

    .card-number {
        font-size: 1rem;
    }

    .card-expiry {
        font-size: 0.85rem;
    }

    .button-group {
        flex-direction: column;
        width: 100%;
        gap: 8px;
    }

    .btn-change-card, .btn-add-card, .btn-cancel-subscription {
        width: 100%;
        padding: 0.7rem 0.5rem;
        font-size: 1rem;
        border-radius: 6px;
        justify-content: center;
    }

    .history-header {
        gap: 4px;
        padding: 0.7rem 0.5rem;
        font-size: 1rem;
        border-radius: 6px 6px 0 0;
        display: flex;
        justify-content: space-around;
    }

    .history-item {
        gap: 4px;
        padding: 0.7rem 0.5rem;
        font-size: 1rem;
        border-radius: 6px 6px 0 0;
        display: flex;
        justify-content: space-around;
    }

    .payment-status {
        padding: 6px 10px;
        font-size: 0.98rem;
        border-radius: 14px;
        margin-top: 2px;
    }

    .modal-overlay {
        align-items: flex-end !important;
        justify-content: center !important;
        padding: 0 !important;
    }

    .modal-confirm, .modal-card {
        width: 100vw !important;
        min-width: unset !important;
        max-width: 100vw !important;
        border-radius: 16px 16px 0 0 !important;
        margin: 0 !important;
        padding: 18px 12px !important;
        box-shadow: 0 -2px 16px rgba(0,0,0,0.4);
    }

    .modal-confirm h3, .modal-card h3 {
        font-size: 1.1rem;
        margin-bottom: 10px;
    }

    .modal-confirm p {
        font-size: 0.98rem;
        margin-bottom: 12px;
    }

    .modal-buttons {
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }

    .btn-confirm, .btn-cancel {
        width: 100%;
        font-size: 1rem;
        padding: 0.7rem 0.5rem;
        border-radius: 6px;
        justify-content: center;
    }

    .card-form .form-group,
    .card-form .form-row {
        flex-direction: column;
        gap: 6px;
    }

    .form-row {
        flex-direction: column !important;
        gap: 6px !important;
    }

    .form-group.half {
        width: 100% !important;
    }
}

.payment-status svg {
    font-size: 10px !important;
    width: 20px !important;
}
@media (max-width: 768px) {
    .content-area {
        padding: 0px 0px;
        margin-bottom: 0;
        border-radius: 0;
        width: 100%;
        min-width: 0;
        max-width: 100vw;
        margin-left: 0;
        margin-right: 0;
    }
}
</style>
